<ngx-fab
  [style]="style()"
  [icon]="icon()"
>
  <ng-content></ng-content>
</ngx-fab>
